export default __webpack_public_path__ + "static/media/bi-cycle.2029d08a.svg";